import PropTypes from "prop-types";

import { ListItemLoader } from "@features/ui";
import { EmptyArray } from "@lib/app.helpers";

import { CareerOptionType } from "../types";
import { CareerOptionItem } from "./career-option.item";

import "./career-options.list.scss";

export const CareerOptionsList = ({
  careers,
  loading,
  onCareerDetailsClick,
  onCareerSelected,
  onRemoveCareerToCompare,
}) => {
  if (loading) {
    return EmptyArray(3).map((_, index) => <ListItemLoader key={index} />);
  }

  if (careers.length === 0) {
    return (
      <div className="no-selected-careers">
        No careers to compare. <br />
        You can add careers from your matches.
      </div>
    );
  }

  return careers?.map((career) => (
    <CareerOptionItem
      career={career}
      key={career.id}
      onCareerDetailsClick={onCareerDetailsClick}
      onCareerSelected={onCareerSelected}
      onRemoveCareerToCompare={onRemoveCareerToCompare}
    />
  ));
};

CareerOptionsList.propTypes = {
  careers: PropTypes.arrayOf(CareerOptionType),
  loading: PropTypes.bool,
  onCareerDetailsClick: PropTypes.func.isRequired,
  onCareerSelected: PropTypes.func.isRequired,
  onRemoveCareerToCompare: PropTypes.func.isRequired,
};
